import { BrightnessPercentIcon } from './BrightnessPercentIcon';

/**
 * author: Michael Irigoyen
 * id CBC38577-44FC-45B5-9454-3D04AA9CEAE3
 * name brightness-percent
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/brightness-percent.svg
 * tags
 * - Shopping 
 */
export const DiscountIcon = BrightnessPercentIcon;
export default DiscountIcon